var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "loginIndex" }, [
    _c("div", { staticClass: "head_box" }, [
      _c("div", { staticClass: "pictureDiv" }, [
        _c("div", [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showImageIndex == 0,
                expression: "showImageIndex==0",
              },
            ],
            attrs: { src: require("@/assets/png/indexBackGroupImage1.png") },
          }),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showImageIndex == 1,
                expression: "showImageIndex==1",
              },
            ],
            attrs: { src: require("@/assets/png/indexBackGroupImage2.png") },
          }),
        ]),
      ]),
      _vm._m(0),
      _vm._m(1),
      _vm._m(2),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "totalNumber" }, [
      _c("div", [
        _c("div", [
          _c("p", [_vm._v("120000"), _c("span", [_vm._v("￥")])]),
          _c("p", [_vm._v("账户余额")]),
        ]),
        _c("div", [
          _c("p", [_vm._v("120000"), _c("span", [_vm._v("分")])]),
          _c("p", [_vm._v("积分")]),
        ]),
        _c("div", [
          _c("p", [_vm._v("120000"), _c("span", [_vm._v("￥")])]),
          _c("p", [_vm._v("奖励金")]),
        ]),
        _c("div", [
          _c("p", [_vm._v("15"), _c("span", [_vm._v("张")])]),
          _c("p", [_vm._v("优惠券")]),
        ]),
      ]),
      _c("div", [
        _c("div", [
          _c("p", [_vm._v("1000"), _c("span", [_vm._v("个")])]),
          _c("p", [_vm._v("客户的询单")]),
        ]),
        _c("div", [
          _c("p", [_vm._v("120000"), _c("span", [_vm._v("个")])]),
          _c("p", [_vm._v("客户的订单")]),
        ]),
        _c("div", [
          _c("p", [_vm._v("120000"), _c("span", [_vm._v("个")])]),
          _c("p", [_vm._v("客户的提问")]),
        ]),
        _c("div", [
          _c("p", [_vm._v("16666"), _c("span", [_vm._v("个")])]),
          _c("p", [_vm._v("客户的评价")]),
        ]),
      ]),
      _c("div", [
        _c("div", [
          _c("p", [_vm._v("1000"), _c("span", [_vm._v("个")])]),
          _c("p", [_vm._v("客户的发票")]),
        ]),
        _c("div", [
          _c("p", [_vm._v("120000"), _c("span", [_vm._v("个")])]),
          _c("p", [_vm._v("我的采购")]),
        ]),
        _c("div", [
          _c("p", [_vm._v("120000"), _c("span", [_vm._v("个")])]),
          _c("p", [_vm._v("待确认的采购")]),
        ]),
        _c("div", [
          _c("p", [_vm._v("16666"), _c("span", [_vm._v("个")])]),
          _c("p", [_vm._v("我的方案")]),
        ]),
      ]),
      _c("div", [
        _c("div", [
          _c("p", [_vm._v("1000"), _c("span", [_vm._v("个")])]),
          _c("p", [_vm._v("我发出的询价")]),
        ]),
        _c("div", [
          _c("p", [_vm._v("120000"), _c("span", [_vm._v("个")])]),
          _c("p", [_vm._v("我收到的回复")]),
        ]),
        _c("div", [
          _c("p", [_vm._v("120000"), _c("span", [_vm._v("个")])]),
          _c("p", [_vm._v("营销活动")]),
        ]),
        _c("div", [
          _c("p", [_vm._v("16666"), _c("span", [_vm._v("个")])]),
          _c("p", [_vm._v("我的收藏")]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "image" }, [
      _c("img", {
        staticStyle: { width: "100%", height: "2.5rem", "object-fit": "cover" },
        attrs: { src: require("@/assets/png/dataManage.png") },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tongjishuju" }, [
      _c("div", [
        _c("div", [
          _c("div", { staticClass: "type" }, [
            _c("div", { staticClass: "typeDiv no1" }, [
              _vm._v("定制"),
              _c("br"),
              _vm._v("线路"),
            ]),
            _c("div", { staticClass: "typeDiv no2" }, [_vm._v("跟团")]),
            _c("div", { staticClass: "typeDiv no3" }, [_vm._v("酒店")]),
            _c("div", { staticClass: "typeDiv no4" }, [_vm._v("景点")]),
            _c("div", { staticClass: "typeDiv no5" }, [_vm._v("用车")]),
          ]),
          _c("div", [
            _c("p", [_vm._v("我客户的交易偏好")]),
            _c("p", [_vm._v("新增粉丝")]),
          ]),
        ]),
        _c("div", [
          _c("div", [
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("span", [_vm._v("人")]),
          ]),
          _c("div", [
            _c("p", [_vm._v("我的累计实名用户")]),
            _c("p", [_vm._v("2021.11.05 13:00:00")]),
            _c("p", [_vm._v("昨日新增 287 环比增长20%")]),
          ]),
        ]),
        _c("div", [
          _c("div", [
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("span", [_vm._v("人")]),
          ]),
          _c("div", [
            _c("p", [_vm._v("我的累计分销达人")]),
            _c("p", [_vm._v("2021.11.05 13:00:00")]),
            _c("p", [_vm._v("昨日新增 287 环比增长20%")]),
          ]),
        ]),
      ]),
      _c("div", [
        _c("div", [
          _c("div", [
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("span", [_vm._v("人")]),
          ]),
          _c("div", [
            _c("p", [_vm._v("我的累计关注")]),
            _c("p", [_vm._v("2021.11.05 13:00:00")]),
            _c("p", [_vm._v("昨日新增 287 环比增长20%")]),
          ]),
        ]),
        _c("div", [
          _c("div", [
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("span", [_vm._v("人")]),
          ]),
          _c("div", [
            _c("p", [_vm._v("我的累计粉丝")]),
            _c("p", [_vm._v("2021.11.05 13:00:00")]),
            _c("p", [_vm._v("昨日新增 287 环比增长20%")]),
          ]),
        ]),
        _c("div", [
          _c("div", [
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("div", { staticClass: "numberDiv" }, [_vm._v("0")]),
            _c("span", [_vm._v("人")]),
          ]),
          _c("div", [
            _c("p", [_vm._v("我的活跃客户数（最近7天）")]),
            _c("p", [_vm._v("2021.11.05 13:00:00")]),
            _c("p", [_vm._v("昨日新增 287 环比增长20%")]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }